import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectSales = (state: RootState) => state.sellOut;

const selectSellOutList = createSelector(
  selectSales,
  (state) => state.sell_out_list
);
const selectSellOutSummary = createSelector(
  selectSales,
  (state) => state.sell_out_summary
);

const selectSellOutIsLoading = createSelector(
  selectSales,
  (state) => state.is_loading
);

const selectMeta = createSelector(selectSales, (state) => state.meta);
const selectFilter = createSelector(selectSales, (state) => state.params);

export const selectors = {
  selectSellOutList,
  selectSellOutSummary,
  selectSellOutIsLoading,
  selectMeta,
  selectFilter
};
